import { endpoints, getTimePeriodObject, symbology, scaleList, getScaleObject } from '../store/StaticVariables';
const lineColor = '#333';
const lineLayers = [
    // {
    //     id: 'ZCTA',
    //     type: 'line',
    //     source: 'esri',
    //     'source-layer': 'ZCTA',
    //     minzoom: getScaleObject('zcta').minZoom,
    //     layout: {
    //         visibility: 'none',
    //         'line-cap': 'round',
    //         'line-join': 'round'
    //     },
    //     paint: {
    //         'line-color': lineColor,
    //         'line-width': 0.25,
    //         'line-opacity': 1,
    //         'line-dasharray': [4, 4]
    //     }
    // },
    // {
    //     id: 'Census',
    //     type: 'line',
    //     source: 'esri',
    //     'source-layer': 'Tract',
    //     minzoom: getScaleObject('census').minZoom,
    //     layout: {
    //         'line-cap': 'round',
    //         'line-join': 'round'
    //     },
    //     paint: {
    //         'line-color': lineColor,
    //         'line-width': 0.25,
    //         'line-opacity': 1
    //     }
    // },
    // {
    //     id: 'County',
    //     type: 'line',
    //     source: 'esri',
    //     'source-layer': 'County',
    //     minzoom: getScaleObject('county').minZoom,
    //     layout: {
    //         'line-cap': 'round',
    //         'line-join': 'round'
    //     },
    //     paint: {
    //         'line-color': lineColor,
    //         'line-width': 0.25,
    //         'line-opacity': 1
    //     }
    // },
    {
        id: 'Lines',
        type: 'line',
        source: 'esri',
        'source-layer': 'State',
        filter: ['has', 'Rate_SYM_ALL'],
        minzoom: 5,
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': lineColor,
            'line-width': {
                base: 1,
                stops: [
                    [5, 0.1],
                    [10, 1]
                ]
            },
            'line-opacity': 0.2
        }
    },
    {
        id: 'Lines_zero',
        type: 'line',
        source: 'esri',
        'source-layer': 'State',
        filter: ['==', 'Rate_SYM_ALL', 0],
        minzoom: 5,
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': lineColor,
            'line-width': {
                base: 1,
                stops: [
                    [5, 0.1],
                    [10, 1]
                ]
            },
            'line-opacity': 0.2
        }
    },
    {
        id: 'State',
        type: 'line',
        source: 'esri',
        'source-layer': 'State',
        layout: {
            'line-cap': 'round',
            'line-join': 'round'
        },
        paint: {
            'line-color': lineColor,
            'line-width': 2,
            'line-opacity': 0.4
        }
    }
];
const generateBaseStyleJson = (time) => {
    const timeAttr = getTimePeriodObject(time).attr;
    const serviceUrl = endpoints.map + timeAttr + '/VectorTileServer';
    return {
        version: 8,
        sprite: 'https://www.arcgis.com/sharing/rest/content/items/2b22eb2401ca455484d68e4c17ce251a/resources/sprites/sprite-1716407536684',
        // sprite: serviceUrl + '/resources/sprites/sprite',
        glyphs: serviceUrl + '/resources/fonts/{fontstack}/{range}.pbf',
        sources: {
            esri: {
                type: 'vector',
                bounds: [-124.743, 24.5175, -66.926, 49.3845],
                minzoom: 0,
                maxzoom: 23,
                scheme: 'xyz',
                url: serviceUrl
            }
        },
        layers: []
    };
};

export const generateChloroplethStyleJson = (args) => {
    const { timePeriod, sourceLayer, mapAttribute: rawMapAttribute, view, scale } = args;
    let mapAttribute = rawMapAttribute.toLowerCase();
    const baseJson = generateBaseStyleJson(timePeriod);
    const colorStep = symbology[scale][mapAttribute];
    const stepLayers = colorStep.map((step) => {
        return {
            id: step.name,
            type: 'fill',
            source: 'esri',
            'source-layer': sourceLayer,
            filter: ['==', mapAttribute, step.val],

            paint: {
                'fill-color': step.color,
                'fill-opacity': 1
                // 'fill-outline-color': step.name === 'none' ? '#cccccc' : lineColor,
                // 'fill-outline-color': lineColor,
                // 'line-opacity': 0.2
            }
        };
    });
    const adjustedLineLayers = [...lineLayers];
    adjustedLineLayers[0]['source-layer'] = sourceLayer;
    adjustedLineLayers[1]['source-layer'] = sourceLayer;
    // console.log(JSON.parse(JSON.stringify(adjustedLineLayers[0].filter)));
    if (adjustedLineLayers[0].filter) adjustedLineLayers[0].filter[1] = mapAttribute;
    if (adjustedLineLayers[1].filter) adjustedLineLayers[1].filter[1] = mapAttribute;
    // console.log()
    // if (view === 'deaths') {
    //     adjustedLineLayers[0].layout.visibility = 'none'; //zcta
    //     adjustedLineLayers[1].layout.visibility = 'visible'; //census
    // } else {
    //     adjustedLineLayers[0].layout.visibility = 'visible'; //zcta
    //     adjustedLineLayers[1].layout.visibility = 'none'; //census
    // }
    const green = '#2dbf3b';
    const blue = '#0000ff';
    const debugLyrs = [
        // {
        //     id: 'debug',
        //     type: 'line',
        //     source: 'esri',
        //     'source-layer': 'Tract',
        //     filter: ['<', 'AGG_COUNT', 2],
        //     layout: {
        //         'line-cap': 'round',
        //         'line-join': 'round'
        //     },
        //     paint: {
        //         'line-color': '#663399',
        //         'line-width': 2,
        //         'line-opacity': 1
        //     }
        // }
        // {
        //     id: 'debugzcta',
        //     type: 'line',
        //     source: 'esri',
        //     'source-layer': 'ZCTA',
        //     filter: ['<', 'AGG_COUNT', 2],
        //     layout: {
        //         'line-cap': 'round',
        //         'line-join': 'round'
        //     },
        //     paint: {
        //         'line-color': '#ff0000',
        //         'line-width': 1,
        //         'line-opacity': 1
        //     }
        // },
        // {
        //     id: 'debug',
        //     type: 'line',
        //     source: 'esri',
        //     'source-layer': 'County',
        //     // filter: ['==', 'Rate_ED', -999],
        //     filter: ['has', 'Rate_SYM_ALL'],
        //     layout: {
        //         'line-cap': 'round',
        //         'line-join': 'round'
        //     },
        //     paint: {
        //         'line-color': '#ff0000',
        //         'line-width': 1,
        //         'line-opacity': 1
        //     }
        // },
        // {
        //     id: 'debu2',
        //     type: 'line',
        //     source: 'esri',
        //     'source-layer': 'County',
        //     // filter: ['==', 'Rate_ED', -999],
        //     filter: ['==', 'Rate_SYM_ALL', 0],
        //     layout: {
        //         'line-cap': 'round',
        //         'line-join': 'round'
        //     },
        //     paint: {
        //         'line-color': blue,
        //         'line-width': 1,
        //         'line-opacity': 1
        //     }
        // }
        // {
        //     id: 'debu3',
        //     type: 'line',
        //     source: 'esri',
        //     'source-layer': 'County',
        //     // filter: ['==', 'Rate_ED', -999],
        //     filter: [
        //         ['==', 'Rate_SYM_ALL', 0],
        //         ['has', ['literal', 'Rate_SYM_ALL']]
        //     ],
        //     layout: {
        //         'line-cap': 'round',
        //         'line-join': 'round'
        //     },
        //     paint: {
        //         'line-color': green,
        //         'line-width': 1,
        //         'line-opacity': 1
        //     }
        // }
    ];
    const patternLayers = [
        {
            id: 'unstable_pattern',
            type: 'fill',
            source: 'esri',
            'source-layer': sourceLayer,
            filter: ['==', mapAttribute, -999],
            paint: {
                'fill-pattern': 'Water area/Inundated area'
            }
        }
    ];

    return Object.assign({}, baseJson, {
        layers: [...stepLayers, ...patternLayers, ...adjustedLineLayers]
        // layers: [...stepLayers, ...patternLayers, ...adjustedLineLayers, ...debugLyrs]
    });
};

export const generateHoverStyleJson = (args) => {
    const { timePeriod } = args;
    const baseJson = generateBaseStyleJson(timePeriod);
    const layers = [
        {
            id: 'selected_feature',
            type: 'line',
            source: 'esri',
            'source-layer': 'State',
            filter: ['==', 'geoid', '0'],
            // filter: ['==', 'GEOID', '0'],
            layout: {
                'line-cap': 'round',
                'line-join': 'round'
            },
            paint: {
                'fill-color': '#ff0000',
                'line-color': '#000000',
                'line-width': 4,
                'line-opacity': 1
            }
        }
    ];
    return Object.assign({}, baseJson, { layers });
};
export const generateInfoStyleJson = (args) => {
    const { timePeriod } = args;
    const baseJson = generateBaseStyleJson(timePeriod);
    const baseHitLayer = {
        id: '',
        type: 'fill',
        source: 'esri',
        'source-layer': '',
        paint: {
            'fill-color': '#000000',
            'fill-opacity': 0.0
        }
    };
    const layers = scaleList.map((scale) => {
        return Object.assign({}, baseHitLayer, { id: scale.slug + '_hit_layer', 'source-layer': scale['source-layer'] });
    });
    return Object.assign({}, baseJson, { layers });
};
